const Plane = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 33"
      width={32}
      height={33}
      {...props}
    >
      <path
        d="M0 11.3h1.68l2.4 3.2h10.04L10 .5h2.32l8.24 14H30c.56 0 1.033.193 1.42.58.387.387.58.86.58 1.42a1.93 1.93 0 01-.58 1.42 1.93 1.93 0 01-1.42.58h-9.44l-8.24 14H10l4.12-14H4.08l-2.4 3.2H0l1.48-5.2L0 11.3z"
      ></path>
    </svg>
  );
};

export default Plane;
